import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import { router } from "./router";
import { i18n } from "./i18n";
import { initTheme } from "./theme";
import { setUnauthorizedHandler } from "./api/client";
import { useAuthStore } from "./stores/auth";
import "./styles/global.css";

initTheme();

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);

// A 401 on any non-auth request means the session is gone — reset auth state
// and bounce to /login (preserving where we were) instead of letting the
// current view render a bare "unauthorized" error.
setUnauthorizedHandler(() => {
  const auth = useAuthStore();
  if (!auth.isAuthenticated()) return;
  auth.markAnonymous();
  const current = router.currentRoute.value;
  if (current.name !== "login") {
    void router.replace({ name: "login", query: { redirect: current.fullPath } });
  }
});

app.mount("#app");

// PWA: register the service worker for installability + offline app shell.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      /* SW registration is best-effort */
    });
  });
}
